import classNames from 'classnames';
import { useState } from 'react';

import { ContentReveal, Flex, Grid, GridItem, Text } from '@farmersdog/corgi-x';
import { Check } from '@farmersdog/corgi-x/icons';

import { GettingStartedBadges } from '../GettingStartedBadges/GettingStartedBadges';

import styles from './PopularPlanOptions.module.css';

/** "Popular Plan Options" card in Recipes Page: Getting Started */
export function PopularPlanOptions({
  preselectedDailyPrice,
  otherOptionDailyPrice,
  preselectedDaysOfFood,
  otherOptionDaysOfFood,
}: {
  preselectedDailyPrice: string;
  otherOptionDailyPrice: string;
  preselectedDaysOfFood: number;
  otherOptionDaysOfFood: number;
}) {
  const [isOptionFlipped, setIsOptionFlipped] = useState(false);
  const handleOnClick = () => {
    // TODO: Call new Segment event
    setIsOptionFlipped(!isOptionFlipped);
    setTimeout(() => {
      setIsOptionFlipped(false);
    }, 5000);
  };
  return (
    <div className={styles.cardWrapper}>
      <Text
        variant="heading-22"
        color="Kale3"
        bold
        align="center"
        as="h3"
        bottomSpacing="sm"
      >
        Popular Plan Options
      </Text>
      <Grid flexDirection={{ xs: 'row', lg: 'column' }} gap="sm">
        <GridItem
          className={classNames(styles.preselected, styles.optionCard)}
          sm={6}
          lg={12}
        >
          <Flex
            direction="column"
            gap="xs"
            justify="center"
            alignItems="center"
          >
            <Text color="Charcoal3" variant="heading-22" bold align="center">
              {preselectedDaysOfFood} Days of Food
            </Text>
            <Text
              color="Charcoal3"
              variant="heading-16"
              bold
              bottomSpacing={{
                xs: 'md',
                lg: 'xs',
              }}
            >
              {preselectedDailyPrice}/day
            </Text>
            <Flex direction="column" gap="sm" alignItems="center">
              <Flex direction="row" gap="xs" alignItems="baseline">
                <Check width={13} height={12} baseColor="Carrot2" />
                <Text bold variant="heading-12">
                  Preselected
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </GridItem>
        {isOptionFlipped && (
          <ContentReveal
            in={isOptionFlipped}
            inAnimation="fade"
            outAnimation="fade"
            inDelay={200}
          >
            <GridItem
              className={classNames(styles.optionCard, styles.additionalOption)}
              sm={6}
              lg={12}
              alignItems="center"
            >
              <Text variant="heading-16" color="kale-2" align="center" as="p">
                This plan is available after checkout
              </Text>
            </GridItem>
          </ContentReveal>
        )}
        {!isOptionFlipped && (
          <ContentReveal
            in={!isOptionFlipped}
            inAnimation="fade"
            outAnimation="fade"
            outDelay={200}
          >
            <GridItem
              className={classNames(styles.optionCard, styles.additionalOption)}
              sm={6}
              lg={12}
            >
              <Flex
                direction="column"
                gap="xs"
                justify="center"
                alignItems="center"
                onClick={handleOnClick}
              >
                <Text
                  color="Charcoal3"
                  variant="heading-22"
                  bold
                  align="center"
                >
                  {otherOptionDaysOfFood} Days of Food
                </Text>
                <Text
                  color="Charcoal3"
                  variant="heading-16"
                  bold
                  align="center"
                  bottomSpacing={{
                    xs: 'md',
                    lg: 'xs',
                  }}
                >
                  {otherOptionDailyPrice}/day
                </Text>
                <GettingStartedBadges badges={['Bulk Discount']} />
              </Flex>
            </GridItem>
          </ContentReveal>
        )}

        <GridItem xs={12}>
          <Text
            as="h5"
            vSpacing="none"
            align="center"
            variant="heading-16"
            color="charcoal-3"
          >
            Bulk discount pricing and other plans available after checkout.
          </Text>
        </GridItem>
      </Grid>
    </div>
  );
}
